import { render, staticRenderFns } from "./AdConsentModal.vue?vue&type=template&id=5b2e7e45&scoped=true"
import script from "./AdConsentModal.vue?vue&type=script&lang=js"
export * from "./AdConsentModal.vue?vue&type=script&lang=js"
import style0 from "./AdConsentModal.vue?vue&type=style&index=0&id=5b2e7e45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2e7e45",
  null
  
)

export default component.exports